import React from 'react';
import { Cell } from '@cognitiv/cyprus-ui';
import classNames from 'classnames';
import { BatchHistoryCellProps } from 'ducks/types/table-types';

import { BATCH_STATES } from './constants';

import cn from 'components/batch-history/BatchHistoryTable.module.scss';

export const IdCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.batch_id}</p>
  </Cell>
);

export const NameCell = ({ row }: BatchHistoryCellProps) => (
  <Cell>
    <p>{row?.batch_name}</p>
  </Cell>
);

export const JobsCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.total_job_count}</p>
  </Cell>
);

export const QueuedCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.queued_job_count}</p>
  </Cell>
);

export const StartingCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.starting_job_count}</p>
  </Cell>
);

export const StoppedCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.stopped_job_count}</p>
  </Cell>
);

export const RunningCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.running_job_count}</p>
  </Cell>
);

export const CompletedCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.succeeded_job_count}</p>
  </Cell>
);

export const FailedCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.failed_job_count}</p>
  </Cell>
);

export const CreatedByCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.created_by}</p>
  </Cell>
);

export const CreatedCell = ({ row }: BatchHistoryCellProps) => (
  <Cell align="center">
    <p>{row?.created_datetime_formatted}</p>
  </Cell>
);

export const StateCell = ({ row, settings }: BatchHistoryCellProps) => {
  const batch_state_id = row?.batch_state_id;
  return (
    <Cell align="center">
      <div style={{ lineHeight: settings ? `${settings.row_height - 8}px` : '' }}>
        <p
          className={classNames(cn.chip, {
            [cn.grey]: batch_state_id === BATCH_STATES.CREATED,
            [cn.red]: batch_state_id === BATCH_STATES.FAILED,
            [cn.orange]: batch_state_id === BATCH_STATES.STOPPED,
            [cn.blue]: batch_state_id === BATCH_STATES.RUNNING,
            [cn.green]: batch_state_id === BATCH_STATES.SUCCEEDED,
          })}
        >
          {row?.batch_state_name}
        </p>
      </div>
    </Cell>
  );
};
